// utils.js
const DEFAULT_ITEM_WEIGHT_GRAMS = 500; // 500g default per item

export function calculateTotalWeight(items) {
    return items.reduce((total, item) => {
      // items weight is in kg, convert to grams
      const weight = item.weight * 1000 || DEFAULT_ITEM_WEIGHT_GRAMS;
      const quantity = item.quantity || 1;
      return total + (weight * quantity);
    }, 0);
  }
  
  export function calculateTotalVolume(items) {
    const defaultDimensions = { length: 20, width: 40, height: 55 }; // cm
    
    return items.reduce((totalVolume, item) => {

      const quantity = item.quantity || 1;
      
      // Use item dimensions if available, otherwise use defaults
      const length = item.length || defaultDimensions.length;
      const width = item.width || defaultDimensions.width;
      const height = item.height || defaultDimensions.height;
      
      const itemVolume = length * width * height;
      return totalVolume + (itemVolume * quantity);
    }, 0);
  }
  
  export function checkDimensionFit(totalVolume, maxDimensions) {
    // maxDimensions should be like { length: 70, width: 40, height: 55 }
    const maxVolume = maxDimensions.length * maxDimensions.width * maxDimensions.height;
    return totalVolume <= maxVolume;
  }